export const Location = {
	DEV_DETAILS_DIALOG: 'DEV_DETAILS_DIALOG',
	CODE_IN_JIRA: 'CODE_IN_JIRA',
	DEVELOPMENT_PANEL_CONFIG: 'DEVELOPMENT_PANEL_CONFIG',
	RELEASES_PANEL_CONFIG: 'RELEASES_PANEL_CONFIG',
} as const;
export type Location = (typeof Location)[keyof typeof Location];
